// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eFg7u","placeholdersHeader":"styles_placeholdersHeader__3oozr","editorStyle":"styles_editorStyle__33aF-","placeholdersBox":"styles_placeholdersBox__3J1AC"};